import { FormControl, UntypedFormGroup } from '@angular/forms';
import { PaysafeFormField } from '../../models/paysafe/paysafe-form-field.enum';
import { PaysafeForm } from '../../models/paysafe/paysafe-form.interface';

export const mockPaysafeForm: PaysafeForm = {
  [PaysafeFormField.BillingAddress]: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
    sameAsAddress: new FormControl(),
  }),
  [PaysafeFormField.AccountName]: new FormControl(null),
  [PaysafeFormField.Address]: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
  }),
  [PaysafeFormField.CardNumber]: new FormControl(null),
  [PaysafeFormField.Cvv]: new FormControl(null),
  [PaysafeFormField.ExpiryDate]: new FormControl(null),
  [PaysafeFormField.MonthlyRenewal]: new FormControl(null),
  [PaysafeFormField.PaperlessPreference]: new FormControl(null),
  [PaysafeFormField.TermsAndConditions]: new FormControl(null),
};
